import React, { Component } from 'react';
import copy from 'clipboard-copy';
import PropTypes from 'prop-types';
import { Container, Image, Button } from 'react-bootstrap';
import shareIcon from '../images/shareIcon.svg';
import { addFoodToFavorite, fetchDrinkApiById, fetchFoodApiById,
  getIngredientList, isFavoriteRecipe } from '../helpers';
import fav from '../images/blackHeartIcon.svg';
import notFav from '../images/whiteHeartIcon.svg';

class ReceitasEmProgresso extends Component {
  constructor() {
    super();
    this.state = {
      ingredientList: [],
      displayShareMesage: false,
      favoriteRecipe: false,
      disable: true,
      currentRecipe: '',
      isDone: '',
    };
    this.fetchDrinkRecipe = this.fetchDrinkRecipe.bind(this);
    this.fetchFoodRecipe = this.fetchFoodRecipe.bind(this);
    this.handleChangeChecked = this.handleChangeChecked.bind(this);
    this.fetchApi = this.fetchApi.bind(this);
    this.updateStorage = this.updateStorage.bind(this);
    this.share = this.share.bind(this);
    this.favoriteThisItem = this.favoriteThisItem.bind(this);
    this.isDisable = this.isDisable.bind(this);
  }

  componentDidMount() {
    this.fetchApi();
  }

  handleChangeChecked(event) {
    const { isDone } = this.state;
    const { name, checked } = event.target;
    this.setState({ isDone: { ...isDone, [name]: checked } }, () => this.isDisable());
  }

  share() {
    const { location } = window;
    const { href } = location;
    const retiraInProgressDoLink = -12;
    const link = href.slice(0, retiraInProgressDoLink);
    copy(link);
    const SHOW_TIME = 3000;
    this.setState({ displayShareMesage: true }, () => {
      setTimeout(() => this.setState({ displayShareMesage: false }), SHOW_TIME);
    });
  }

  fetchApi() {
    const { match: { params: { id } } } = this.props;
    const { location } = window;
    const { href } = location;
    if (href.includes('comida')) {
      this.fetchFoodRecipe(id);
    }
    if (href.includes('bebida')) {
      this.fetchDrinkRecipe(id);
    }
  }

  async fetchDrinkRecipe(drinkId) {
    const storage = JSON.parse(localStorage.getItem('isDone'));
    const recipe = await fetchDrinkApiById(drinkId);
    const ingredients = getIngredientList(recipe);
    const arrIngredientes = Object.values(ingredients);
    const isDone = storage || arrIngredientes.reduce((acc, crr) => {
      acc = { ...acc, [crr.item]: false };
      return acc;
    }, {});

    const isFavorite = isFavoriteRecipe(drinkId);
    this.setState({
      isDone,
      ingredientList: arrIngredientes,
      currentRecipe: recipe,
      favoriteRecipe: isFavorite,
    });
    this.isDisable();
  }

  async fetchFoodRecipe(foodId) {
    const storage = JSON.parse(localStorage.getItem('isDone'));
    const recipe = await fetchFoodApiById(foodId);
    const ingredients = getIngredientList(recipe);
    const arrIngredientes = Object.values(ingredients);
    const isDone = storage || arrIngredientes.reduce((acc, crr) => {
      acc = { ...acc, [crr.item]: false };
      return acc;
    }, {});

    const isFavorite = isFavoriteRecipe(foodId);
    this.setState({
      isDone,
      ingredientList: arrIngredientes,
      currentRecipe: recipe,
      favoriteRecipe: isFavorite,
    });
    this.isDisable();
  }

  favoriteThisItem() {
    let variavel = '';
    const { currentRecipe } = this.state;
    const { location } = window;
    const { href } = location;
    if (href.includes('comida')) {
      variavel = 'comida';
    }
    if (href.includes('bebida')) {
      variavel = 'bebida';
    }

    const done = addFoodToFavorite(currentRecipe, variavel);
    this.setState({ favoriteRecipe: done });
  }

  inputCards() {
    const { ingredientList, isDone, displayShareMesage,
      favoriteRecipe, disable, currentRecipe } = this.state;
    const { history } = this.props;
    let thumb = '';
    let h1 = '';
    if (history.location.pathname.includes('bebida')) {
      thumb = currentRecipe ? currentRecipe.strDrinkThumb : '';
      h1 = currentRecipe ? currentRecipe.strDrink : '';
    } else {
      thumb = currentRecipe ? currentRecipe.strMealThumb : '';
      h1 = currentRecipe ? currentRecipe.strMeal : '';
    }
    return (
      <div className="recipe-detail-wrapper">
        <Container>
          <div className="recipe-detail-header">
            <div className="recipe-detail-photo-wrapper">
              <Image
                data-testid="recipe-photo"
                alt={ `Foto de ${h1}` }
                src={ thumb }
                className="linkImage recipe-detail-photo"
              />
            </div>
            
            <div className="recipe-detail-meta">
              <span className="recipe-detail-badge" data-testid="recipe-category">
                {currentRecipe.strCategory || currentRecipe.strAlcoholic || 'Em Progresso'}
              </span>
              <h1 data-testid="recipe-title" className="recipe-detail-title">
                {h1}
              </h1>

              <div className="recipe-detail-actions">
                <button
                  className="recipe-button"
                  type="button"
                  aria-label="Compartilhar receita em progresso"
                  onClick={ () => this.share() }
                >
                  <img
                    alt="Compartilhar"
                    data-testid="share-btn"
                    src={ shareIcon }
                  />
                </button>
                <button
                  className="recipe-button"
                  type="button"
                  aria-label={favoriteRecipe ? 'Remover dos favoritos' : 'Favoritar receita'}
                  onClick={ this.favoriteThisItem }
                >
                  <img
                    src={ favoriteRecipe ? fav : notFav }
                    alt="Favoritar"
                    data-testid="favorite-btn"
                  />
                </button>
              </div>

              {displayShareMesage && (
                <div className="share-toast" role="status" aria-live="polite">
                  ✨ Link copiado para a área de transferência!
                </div>
              )}
            </div>
          </div>

          <div className="recipe-detail-section">
            <h4>Ingredientes e Passos (Marque para concluir)</h4>
            <div className="recipe-instructions-box d-flex flex-column gap-3">
              {ingredientList.map((obj, index) => (
                <label
                  key={ index }
                  htmlFor={ obj.item }
                  className={`d-flex align-items-center gap-3 p-2 rounded ${isDone[obj.item] ? 'checkboxInProgressChecked text-decoration-line-through text-muted' : 'nunCheck fw-semibold'}`}
                  data-testid={ `${index}-ingredient-step` }
                  style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                >
                  <input
                    name={ obj.item }
                    type="checkbox"
                    id={ obj.item }
                    checked={ isDone[obj.item] || false }
                    onChange={ (event) => this.handleChangeChecked(event) }
                    style={{ width: '20px', height: '20px', accentColor: 'var(--color-primary)', cursor: 'pointer' }}
                  />
                  <span>
                    <strong>{obj.item}</strong> {obj.quantity ? `— ${obj.quantity}` : ''}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="recipe-detail-section">
            <h4>Modo de Preparo</h4>
            <div data-testid="instructions" className="recipe-instructions-box">
              {currentRecipe.strInstructions}
            </div>
          </div>

          <div className="recipe-start-sticky">
            <Button
              block
              className="default-button green start-recipe-btn-custom"
              type="button"
              data-testid="finish-recipe-btn"
              disabled={ disable }
              onClick={ () => history.push('/receitas-feitas') }
            >
              🎉 Finalizar Receita &rarr;
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  updateStorage() {
    const { isDone } = this.state;
    if (!isDone) return;
    localStorage.setItem('isDone', JSON.stringify(isDone));
  }

  isDisable() {
    const { isDone } = this.state;
    if (isDone === '') return;
    const str = JSON.stringify(isDone);
    if (str.includes('false')) {
      this.setState({ disable: true });
    } else {
      this.setState({ disable: false });
    }
  }

  render() {
    this.updateStorage();
    return (
      <div>
        {this.inputCards()}
      </div>
    );
  }
}

ReceitasEmProgresso.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
};

export default ReceitasEmProgresso;
